class Incrementer {
  constructor(options = {}) {
    this.config = {
      module: () => document.querySelectorAll('[data-module="incrementer"]'),
      ...options
    };
  }

  init() {
    const { module } = this.config;

    module().forEach(_incrementer => {
      const incrementer = _incrementer;
      const { initialized } = incrementer.dataset;

      if (initialized != null && initialized) return;

      incrementer.dataset.initialized = true; // skip initialized items

      const buttonMinus = incrementer.querySelector('[data-type="minus"]');
      const buttonPlus = incrementer.querySelector('[data-type="plus"]');
      let quantityElement = incrementer.querySelector('input[name="quantity"]');
      const splittedId = quantityElement.id.split('-');
      const productId = splittedId[splittedId.length - 1];
      const productAddBtn = document.querySelector(`button[data-product-id="${productId}"]`);
      buttonMinus.addEventListener('click', () => {
        quantityElement = incrementer.querySelector('input[name="quantity"]');
        const min = quantityElement.min && quantityElement.min !== 'null' ? quantityElement.min : 1;
        if (parseInt(quantityElement.value, 10) > min) {
          quantityElement.value = parseInt(quantityElement.value, 10) - 1;
        }

        if (productAddBtn) {
          productAddBtn.dataset.quantity = quantityElement.value;
        }
      });
      buttonPlus.addEventListener('click', () => {
        quantityElement = incrementer.querySelector('input[name="quantity"]');
        const max =
          quantityElement.max && quantityElement.max !== 'null' ? quantityElement.max : 99999999;
        if (parseInt(quantityElement.value, 10) < max) {
          quantityElement.value = parseInt(quantityElement.value, 10) + 1;
        } else {
          quantityElement.value = max;
          // send toaster event
          window.dispatchEvent(
            new CustomEvent('toast', {
              detail: {
                type: 'warning',
                text:
                  buttonPlus.dataset.maxReached ||
                  'Het gekozen aantal stuks is niet voorradig voor dit product'
              }
            })
          );
        }

        if (productAddBtn) {
          productAddBtn.dataset.quantity = quantityElement.value;
        }
      });

      quantityElement.addEventListener('change', () => {
        if (productAddBtn) {
          productAddBtn.dataset.quantity = quantityElement.value;
        }
      });
    });
  }
}

export default Incrementer;
